import { Box } from '@mui/material';
import { TextBlock } from '../../../Atoms/Text';
import { DiscoveryQuestion } from '../../../../types/advise';
import { shownAnswer } from './DiscoveryPanel.calc';

const answerText = (question: DiscoveryQuestion): string => {
  const answer = shownAnswer(question);
  if (Array.isArray(answer)) return answer.length > 0 ? answer.join(', ') : '—';
  if (typeof answer === 'boolean') return answer ? 'Yes' : 'No';
  if (answer === null || answer === undefined || answer === '') return '—';
  return String(answer);
};

export const DiscoveryReadOnlyAnswer = ({ question }: { question: DiscoveryQuestion }) => (
  <Box>
    <TextBlock
      size="sm14"
      color="grey8"
      className="whitespace-pre-wrap">
      {answerText(question)}
    </TextBlock>
    {question.has_notes && question.value?.notes && (
      <TextBlock
        size="sm14"
        color="grey6"
        className="mt-1 whitespace-pre-wrap">
        {`Notes: ${question.value.notes}`}
      </TextBlock>
    )}
  </Box>
);
